import React from 'react';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import Utility from './../../utils/Utility';
import {
  HiOutlineOfficeBuilding,
  HiOutlineCurrencyDollar,
  HiOutlineCalendar,
  HiOutlineArrowRight,
} from 'react-icons/hi';

const AuctionItem = ({ auction, auctionType }) => {
  const navigate = useNavigate();
  const formattedDate = format(new Date(auction.publishedDate), 'dd MMM yyyy');

  const handleNavigation = () => {
    if (auctionType === 'DirectAwards') {
      navigate(`/achizitii-directe/${auction.auctionId}`);
    } else if (auctionType === 'ProcurementProcedures') {
      navigate(`/licitatii/${auction.auctionId}`);
    }
  };

  return (
    <div
      className="bg-gradient-to-br from-indigo-50 to-white rounded-2xl shadow-lg hover:shadow-indigo-200 hover:scale-105 transition-all duration-300 p-6 cursor-pointer flex flex-col gap-4 border-t-4 border-indigo-400 group"
      onClick={handleNavigation}
    >
      {/* Header: ID + Titlu */}
      <div className="flex items-center justify-between gap-2">
        <h2 className="text-indigo-600 font-bold text-lg">
          #{auction.auctionId}
        </h2>
        <HiOutlineArrowRight className="text-indigo-400 text-2xl group-hover:text-green-500 transition" />
      </div>
      <h3 className="text-2xl font-extrabold text-gray-800 group-hover:text-indigo-600 transition mb-1">
        {auction.auctionTitle}
      </h3>
      <div className="flex items-center gap-2 text-gray-500 text-sm mb-2">
        <HiOutlineOfficeBuilding className="text-green-500 text-lg" />
        <span>
          {auction.city && auction.city !== 'Undefined'
            ? auction.city
            : 'Locație necunoscută'}
          , {auction.authorityName}
        </span>
      </div>
      {/* Info: Valoare + Data */}
      <div className="flex flex-wrap gap-6 items-center justify-between mt-2">
        <div className="flex items-center gap-2 text-gray-700">
          <HiOutlineCurrencyDollar className="text-green-600 text-xl" />
          <span className="font-semibold">
            {Utility.ConvertEstimatedValue(auction.estimatedValue)}{' '}
            {auction.currency}
          </span>
        </div>
        <div className="flex items-center gap-2 text-gray-700">
          <HiOutlineCalendar className="text-indigo-500 text-xl" />
          <span className="italic">Publicată la: {formattedDate}</span>
        </div>
      </div>
    </div>
  );
};

export default AuctionItem;
